import ClientCalendar from './ClientCalendar';
import ClientDetail from './ClientDetail';
import ClientList from './ClientList';
import ClientNew from './ClientNew';
import Status from './Status';
import CallStatus from './CallStatus';
import MatchDifficulty from './MatchDifficulty';
import LeadQuality from './LeadQuality';
import ClosedLostReason from './ClosedLostReason';

export default {
  ClientCalendar,
  ClientDetail,
  ClientList,
  ClientNew,
  Status,
  CallStatus,
  MatchDifficulty,
  LeadQuality,
  ClosedLostReason,
};
